import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getFormUrl } from '@/utils/form';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Main Footer */}
        <div className="py-14 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                精
              </div>
              <span className="font-heading font-bold text-lg text-background-50 tracking-wide">
                精品久久久
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              高品质精选内容长效平台，汇聚经久不衰的优质内容与精品资源，为您提供持久、稳定、高价值的极致体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer">
                <i className="ri-chat-smile-2-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-5 text-sm tracking-wide">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-5 text-sm tracking-wide">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  投稿指南
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  版权声明
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-5 text-sm tracking-wide">
              订阅精选
            </h4>
            <p className="text-sm text-background-400 mb-4 leading-relaxed">
              每周五为您推送精选内容，不错过任何一篇好文章。
            </p>
            <form
              data-readdy-form="true"
              id="footer-newsletter-form"
              action="https://form.readdy.ai/submit"
              method="POST"
              target="_blank"
              className="flex flex-col gap-2.5"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱地址"
                required
                className="w-full px-3.5 py-2.5 rounded-lg bg-background-800 border border-background-700 text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                className="w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 精品久久久 Jingpin999.com 版权所有
          </p>
          <p className="text-xs text-background-600">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener" className="hover:text-background-400 transition-colors cursor-pointer">
              京ICP备2025000001号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}